import { useEffect, useState } from 'react';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { getAppBuilderCurrentStyleValue } from 'app/app/editor/tabs/settings/style-editor/StylesEditorContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useInstallFont } from 'hooks/useFont';
import { useAppBuilderContext } from 'app/app/editor/context';
import { components } from 'react-select';
import { Box } from '@mui/material';

interface FontFieldProps {
    formState: any;
    propertyName: string;
    onChangeStyle: (value: any) => void;
}

const SelectedValueComponent = (props: any) => {
    let label = props.data.label;
    if (props.data.value != '') {
        const groupIndex = props.options.findIndex((group: any) => {
            return group?.options && group.options.find((item: any) => item.value == props.data.value);
        });
        if (groupIndex !== -1) label = props.options[groupIndex].label + ':  ' + label;
    }
    return (
        <components.SingleValue {...props}>
            <Box>{label}</Box>
        </components.SingleValue>
    );
};

export default function FontField({ propertyName, formState, onChangeStyle = () => {} }: FontFieldProps) {
    const ctx = useAppBuilderContext();
    const userBrandThemeProperties = useSelector((state: any) => state.auth?.userInfo?.brandThemeProperties);
    const fontList = useSelector((state: any) => state.font.list);
    const dispatch = useDispatch();
    const [value, setValue] = useState('');
    const [availableFonts, setAvailableFonts] = useState<any>([]);

    useEffect(() => {
        const fonts: any = [
            {
                label: 'None',
                value: '',
            },
            {
                label: 'Inter',
                value: 'Inter, Arial, Helvetica, sans-serif',
            },
            {
                label: 'JetBrains Mono',
                value: '"JetBrains Mono", monospace',
            },
        ];
        /*const fontVariables = (ctx.page?.cssVariables ?? []).filter((variable) => {
            return variable.type == 'font';
        });
        if (fontVariables.length) {
            const newVariableOptions: any = [];
            fontVariables.forEach((variable) => {
                newVariableOptions.push({
                    label: `${variable.title}`,
                    value: `var(--${variable.name})`,
                });
            });
            fonts.push({
                label: 'Style Variable',
                options: newVariableOptions,
            });
        }*/

        const newThemeOptions: any = [];
        (userBrandThemeProperties?.fonts ?? []).forEach((font: any) => {
            newThemeOptions.push({
                label: font.font_name,
                value: `CustomFont_${font.brand_theme_font_id}`,
            });
            useInstallFont(font.brand_theme_font_id, font.file_name, fontList, dispatch);
        });
        if (newThemeOptions.length) {
            fonts.push({
                label: 'Theme Font',
                options: newThemeOptions,
            });
        }

        setAvailableFonts(fonts);
    }, []);

    useEffect(() => {
        setValue(getAppBuilderCurrentStyleValue(formState, propertyName));
    }, [getAppBuilderCurrentStyleValue(formState, propertyName)]);

    const handleChangeFont = (value: any) => {
        setValue(value);
        onChangeStyle({ [propertyName]: value });
    };
    return (
        <>
            <ReactSelect
                data={availableFonts}
                value={[value]}
                update={handleChangeFont}
                overrideComponents={{
                    SingleValue: SelectedValueComponent,
                }}
            />
        </>
    );
}
